import { createApp } from 'vue';
import ProductCarouselBlock from './ProductCarouselBlock.vue';
import 'shared/styles/components/_c-content-library-carousel.scss';

const productCarouselBlocks = [...document.querySelectorAll('[data-product-carousel-block]')];

if (productCarouselBlocks) {
	productCarouselBlocks.forEach(productCarouselBlock => {
		const app = createApp({
			name: 'ProductCarouselBlockApp',
		});
		app.component('product-carousel-block', ProductCarouselBlock);
		app.mount(productCarouselBlock);
	});
}